export default "__VITE_ASSET__dr4MX1pZ__"